import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackDifficultyAnalysis, setPage } from '../../../../../../apps/frontend/src/redux/slices/packSlice';

export const useDifficultyAnalysis = (packId, filter) => {
  const dispatch = useDispatch();
  const {
    difficultyAnalysis: { data, loading, error },
    filters,
  } = useSelector((state) => state.pack);

  useEffect(() => {
    if (packId) {
      dispatch(fetchPackDifficultyAnalysis({ packId, page: filters?.page || 1 }));
    }
  }, [dispatch, packId, filters]);

  return {
    data,
    loading,
    error,
    page: filters?.page || 1,
    setPage: (newPage) => dispatch(setPage(newPage)),
  };
};
